export const VERY_LOW_THRESHOLD = 25;
export const LOW_THRESHOLD = 50;
export const MEDIUM_THRESHOLD = 75;
export const HIGH_THRESHOLD = 100;

export const getHealthColorClass = (health: number) => {
  if (health < LOW_THRESHOLD) return 'text-contentGreen';
  if (health < MEDIUM_THRESHOLD) return 'text-contentOrange';
  return 'text-contentRed';
};
